import React from 'react';
import privateIcon from '../../assets/lock.svg';
import publicIcon from '../../assets/world.svg';
import '../Header/Header.css';
import { MindMapContext } from '../../Context/contex';

const PrivacyIcon = () => {
    const { documentInfo } = MindMapContext();
    const privacyId = documentInfo?.privacyId;
    const isPrivate = privacyId === 2;
    return (
        <img
            src={isPrivate ? privateIcon : publicIcon}
            alt={isPrivate ? 'Private document' : 'Public document'}
            className={`privacy-icon ${isPrivate ? 'privacy-icon--private' : 'privacy-icon--public'}`}
        />
    );
};

export default PrivacyIcon;
